<div class="overlay-medium">
    <router-outlet></router-outlet>
</div>